import { SEGMENTS } from '@sparknz/journeys-common';

import { Segment } from 'shared/hooks';

export const getMetaDataTitle = (
  pageTitle: string | number,
  segment?: Segment,
): string => {
  switch (segment) {
    case SEGMENTS.LARGE_BUSINESS:
      return `${pageTitle} | Large Business & Government | Spark NZ`;
    case SEGMENTS.BUSINESS:
      return `${pageTitle} | Spark Business NZ`;
    default:
      return `${pageTitle} | Spark NZ`;
  }
};
